(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-collection-faq')) {
    class ProductCollectionFaq extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-faq-ready')) return;

        this.controller = new AbortController();
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.setAttribute('data-faq-ready', '');

        for (const item of this.items) {
          const trigger = item.querySelector('[data-faq-trigger]');
          if (!trigger) continue;

          trigger.addEventListener('click', () => this.toggleItem(item), {
            signal: this.controller.signal,
          });
        }

        const initialItem = this.dataset.openFirst === 'true' ? this.items[0] : null;
        this.openItem(initialItem || null);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.removeAttribute('data-faq-ready');
      }

      toggleItem(item) {
        const trigger = item.querySelector('[data-faq-trigger]');
        const shouldOpen = trigger?.getAttribute('aria-expanded') !== 'true';
        this.openItem(shouldOpen ? item : null);
      }

      openItem(openItem) {
        for (const item of this.items) {
          this.setItemState(item, item === openItem);
        }
      }

      setItemState(item, isOpen) {
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        if (!trigger || !panel) return;

        item.classList.toggle('is-open', isOpen);
        trigger.setAttribute('aria-expanded', String(isOpen));
        panel.setAttribute('aria-hidden', String(!isOpen));
        panel.inert = !isOpen;
      }
    }

    customElements.define('product-collection-faq', ProductCollectionFaq);
  }

  } catch(e) { console.error(e); }
})();
})();
